import { getAxisData, getAggregation, getAggregationDate, getXAxisBreakdown } from "../../../../lib/services/forceBI";
import { CHART_TYPES } from "../../constants";
const getIsReadOnly = _ref => {
  let {
    fieldId,
    data
  } = _ref;
  if (fieldId === 'yAxis' && !(data !== null && data !== void 0 && data.entity)) return true;
  if (fieldId === 'xAxis' && !(data !== null && data !== void 0 && data.xAxisEntity)) return true;
  if (fieldId === 'xAxisEntity' && !(data !== null && data !== void 0 && data.entity)) return true;
  if (fieldId === 'xAxisBreakdown' && !(data !== null && data !== void 0 && data.xAxisBreakdownEntity)) return true;
  if (fieldId === 'xAxisBreakdownEntity' && !(data !== null && data !== void 0 && data.entity)) return true;
  return false;
};
const getIsRequired = _ref2 => {
  var _data$xAxis;
  let {
    fieldId,
    data
  } = _ref2;
  if (fieldId === 'xAxisAggregationDate' && data !== null && data !== void 0 && data.xAxis && data !== null && data !== void 0 && (_data$xAxis = data.xAxis) !== null && _data$xAxis !== void 0 && _data$xAxis.isDateField) return true;
  return false;
};
const getIsHidden = _ref3 => {
  let {
    fieldId,
    data
  } = _ref3;
  if (fieldId === 'xAxisBreakdown' && ((data === null || data === void 0 ? void 0 : data.chartType) === CHART_TYPES.pie || (data === null || data === void 0 ? void 0 : data.chartType) === CHART_TYPES.doughnut)) {
    return true;
  }
  return false;
};
const shouldRenderField = _ref4 => {
  var _data$xAxis2, _data$xAxisBreakdown;
  let {
    fieldId,
    data
  } = _ref4;
  if (fieldId === 'xAxisAggregationDate' && (!(data !== null && data !== void 0 && data.xAxis) || !(data !== null && data !== void 0 && (_data$xAxis2 = data.xAxis) !== null && _data$xAxis2 !== void 0 && _data$xAxis2.isDateField))) {
    return false;
  } else if (fieldId === 'xAxisBreakdownAggregationDate' && (!(data !== null && data !== void 0 && data.xAxisBreakdown) || !(data !== null && data !== void 0 && (_data$xAxisBreakdown = data.xAxisBreakdown) !== null && _data$xAxisBreakdown !== void 0 && _data$xAxisBreakdown.isDateField))) {
    return false;
  }
  return true;
};
export const afterOnChange = _ref5 => {
  let {
    fieldId,
    value,
    setOptions
  } = _ref5;
  if (fieldId === 'entity' && value && setOptions) {
    Promise.all([getAxisData(value, 'y'), getAxisData(value, 'x')]).then(_ref6 => {
      let [yData, xData] = _ref6;
      return setOptions({
        y: yData || [],
        x: xData || []
      });
    });
  }
};
const getAxisOptions = axis => entity => () => {
  return getAxisData(entity, axis);
};
const getXAxisBreakdownOptions = entity => () => {
  return getXAxisBreakdown(entity);
};
const getCustomAggregationOptions = _ref7 => {
  let {
    data
  } = _ref7;
  return () => {
    return new Promise((resolve, reject) => {
      getAggregation().then(options => {
        var _data$yAxis;
        const yAxisValue = (data === null || data === void 0 ? void 0 : (_data$yAxis = data.yAxis) === null || _data$yAxis === void 0 ? void 0 : _data$yAxis.value) || '';
        let isNumeric = false;
        let finalOptions = options;

        // Those yAxis options containing 'id' after '.' should be considered as numeric
        // and only have one yAxisAggregation method which is 'count'.
        if (yAxisValue && yAxisValue.split('.')[1] === 'id') isNumeric = true;
        if (isNumeric && options) {
          finalOptions = options.filter(current => current.value === 'count');
        }
        resolve(finalOptions);
      });
    });
  };
};
export const getCrudSchema = _ref8 => {
  let {
    t
  } = _ref8;
  return [{
    title: t('label_info'),
    show: true,
    fields: [{
      id: 'chartType',
      type: 'chartSelector',
      label: t('label_chart'),
      isRequired: true
    }, {
      id: 'title',
      type: 'text',
      label: t('label_forcebi_crud_input_title'),
      placeholder: t('label_forcebi_crud_input_title_placeholder'),
      isRequired: true
    },
    // for entity we use preloaded options to reduce time of loading options
    // is the only field where we can do that because the options do not depend on other fields selection
    {
      id: 'entity',
      type: 'singleValueList',
      label: t('label_forcebi_crud_input_entity'),
      hint: t('label_forcebi_crud_input_entity_description'),
      placeholder: t('label_forcebi_crud_placeholder_select_entity'),
      isRequired: true
    }, {
      id: 'yAxis',
      type: 'singleValueList',
      label: t('label_forcebi_crud_input_y_axis'),
      hint: t('label_forcebi_crud_input_y_axis_description'),
      placeholder: t('label_selectone'),
      placeholderReadOnly: t('label_disabled'),
      getIsReadOnly,
      isRequired: true,
      parentId: 'entity',
      loadOptions: getAxisOptions('y'),
      cacheOptions: false
    }, {
      id: 'xAxisGroup',
      type: 'selectWithEntity',
      label: t('label_forcebi_crud_input_x_axis'),
      parentId: 'entity',
      isRequired: true,
      subFields: [
      // This first field is a field we don't have to send to backend it's just to make the CRUD more understandable for the user.
      {
        id: 'xAxisEntity',
        placeholder: t('label_forcebi_crud_placeholder_select_entity'),
        placeholderReadOnly: t('label_disabled'),
        loadCustomOptions: getEntityOptions,
        isRequired: true,
        getIsReadOnly
      }, {
        id: 'xAxis',
        hint: t('label_forcebi_crud_input_x_axis_description'),
        placeholder: t('label_selectone'),
        placeholderReadOnly: t('label_disabled'),
        getIsReadOnly,
        isRequired: true,
        parentId: 'entity',
        loadOptions: getAxisOptions('x'),
        cacheOptions: false
      }]
    }, {
      id: 'xAxisAggregationDate',
      type: 'singleValueList',
      label: t('label_aggregation_date'),
      hint: t('label_aggregation_date_description'),
      placeholder: t('label_selectone'),
      getIsReadOnly,
      getIsRequired,
      loadOptions: getAggregationDate,
      shouldRenderField: shouldRenderField
    }, {
      id: 'yAxisAggregation',
      type: 'singleValueList',
      label: t('label_aggregation_method'),
      hint: t('label_aggregation_method_description'),
      placeholder: t('label_selectone'),
      getIsReadOnly,
      isRequired: true,
      loadCustomOptions: getCustomAggregationOptions,
      cacheOptions: false
    }, {
      id: 'xAxisBreakdownGroup',
      type: 'selectWithEntity',
      label: t('label_x_axis_breakdown'),
      getIsHidden,
      subFields: [{
        id: 'xAxisBreakdownEntity',
        placeholder: t('label_forcebi_crud_placeholder_select_entity'),
        placeholderReadOnly: t('label_disabled'),
        loadCustomOptions: getEntityOptions,
        getIsReadOnly
      }, {
        id: 'xAxisBreakdown',
        hint: t('label_x_axis_breakdown_description'),
        placeholder: t('label_selectone'),
        placeholderReadOnly: t('label_disabled'),
        getIsReadOnly,
        parentId: 'entity',
        loadOptions: getXAxisBreakdownOptions,
        cacheOptions: false
      }]
    }, {
      id: 'xAxisBreakdownAggregationDate',
      type: 'singleValueList',
      label: t('label_x_axis_breakdown_aggregation_date'),
      hint: t('label_x_axis_breakdown_aggregation_date_description'),
      placeholder: t('label_selectone'),
      getIsReadOnly,
      getIsHidden,
      isRequired: false,
      loadOptions: getAggregationDate,
      shouldRenderField: shouldRenderField
    }]
  }];
};

// We define the entity options here to have them accessible immediately and not having to wait for responses
// when matching entities from xAxis and xAxisBreakdown
export const getEntityOptions = _ref9 => {
  let {
    t
  } = _ref9;
  return [{
    label: t('title_accounts'),
    value: 'empresas'
  }, {
    label: t('title_contacts'),
    value: 'contactos'
  }, {
    label: t('title_opportunities'),
    value: 'expedientes'
  }, {
    label: t('title_activities'),
    value: 'activities'
  }, {
    label: t('label_salesorders'),
    value: 'tblsalesorders'
  }];
};

// Within sales orders options, we can find also productos and tblsalesorderlines, something similar happens with activities and gestiones.
// We need to show them in the dropdown when sales orders is selected
// We also need to map the related entities to the main entity
// This is used to show the related entities in the dropdown when the main entity is selected
export const getRelatedEntities = () => {
  return {
    tblsalesorders: ['tblsalesorderslines', 'productos'],
    activities: ['gestiones']
  };
};

// This serves the same purpose as getRelatedEntities but in reverse. Helps to identify the correct entity for each related entity.
export const getRelatedEntitiesReverse = () => {
  return {
    tblsalesorderslines: 'tblsalesorders',
    productos: 'tblsalesorders',
    gestiones: 'activities'
  };
};